// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"60cfd81c","703":"658809df","787":"1f1ff0d4"}[chunkId] + ".chunk.js";
};